import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getClassDropdown } from "app/services/schoolService/school.service";

const initialState = {
  classList: [],
  lastFetched: null,
  isLoading: false,
};

// Thunk to fetch class data
export const fetchClassData = createAsyncThunk(
  "classData/fetchClassData",
  async (schoolId, { rejectWithValue }) => {
    try {
      const response = await getClassDropdown(schoolId);
      return response?.data?.list || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const classDataSlice = createSlice({
  name: "classData",
  initialState,
  reducers: {
    setClassList: (state, action) => {
      // Redux Toolkit uses Immer internally, so we can mutate state directly
      state.classList = action.payload;
      state.lastFetched = Date.now();
      state.isLoading = false;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    clearClassList: (state) => {
      state.classList = [];
      state.lastFetched = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClassData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchClassData.fulfilled, (state, action) => {
        state.classList = action.payload;
        state.lastFetched = Date.now();
        state.isLoading = false;
      })
      .addCase(fetchClassData.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { setClassList, setLoading, clearClassList } =
  classDataSlice.actions;
export default classDataSlice.reducer;

// Selectors
export const selectClassList = (state) => state.classData?.classList || [];
export const selectClassDataLastFetched = (state) =>
  state.classData?.lastFetched;
export const selectClassDataLoading = (state) => state.classData?.isLoading;